<template>
  <div>
    <el-row :gutter="24">
      <el-col :span="8">
        <el-select v-model="form.provinceid"
                   placeholder="请选择"
                   @visible-change="onGetProvinces"
                   @change="onProvinceChange">
          <el-option
            v-for="item in provinces"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8">
        <el-select v-model="form.cityid"
                   placeholder="请选择"
                   @visible-change="onGetCitys"
                   :disabled="!form.provinceid"
                   @change="onCityChange">
          <el-option
            v-for="item in citys"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8">
        <el-select v-model="form.areaid"
                   placeholder="请选择"
                   @visible-change="onGetAreas"
                   :disabled="!form.cityid"
                   @change="onAreaChange">
          <el-option
            v-for="item in areas"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>

      </el-col>

    </el-row>
  </div>
</template>

<script>

export default {
  components: {},
  props: {},
  data () {
    return {
      outerVisible: false,
      innerVisible: false,
      activeName: 'list',
      form: {
        provinceid: null,
        cityid: null,
        areaid: null,
      },
      provinces: [],
      citys: [],
      areas: [],
    }
  },
  methods: {
    onGetProvinces (status) {
      if (status === true && this.provinces.length <= 0) {
        request.alert('getProvinces').then(({data}) => {
          this.provinces = data
        })
      }
    },
    onGetCitys (status) {
      if (status === true && this.citys.length <= 0 && this.form.provinceid) {
        request.alert('getCities', {pid: this.form.provinceid}).then(({data}) => {
          this.citys = data
        })
      }
    },
    onGetAreas (status) {
      if (status === true && this.areas.length <= 0 && this.form.cityid) {
        request.alert('getDistricts', {pid: this.form.cityid}).then(({data}) => {
          this.areas = data
        })
      }
    },
    onGetData () {
      if (this.form.areaid) {
        return this.form.areaid
      } else if (this.form.cityid) {
        return this.form.cityid
      } else {
        return this.form.provinceid
      }
    },
    onProvinceChange () {
      this.citys = []
      this.form.cityid = null
    },
    onCityChange () {
      this.areas = []
      this.form.areaid = null
    },
    onAreaChange () {

    },
  },
}
</script>




// WEBPACK FOOTER //
// src/views/area/components/AreaSearch.vue